// extracted by mini-css-extract-plugin
export var aircallIframe = "_ib-3";
export var fabContainer = "_ib-5";
export var fabRinging = "_ib-6";
export var loadingOverlay = "_ib-4";
export var pulse = "_ib-7";
export var widgetContent = "_ib-2";
export var widgetPanel = "_ib-0";
export var widgetPanelExpanded = "_ib-1";